<template>
    <div class="miniMpContent MiniParlaySlip_view">
        <div class="miniMpContent-odds">
            <div class="sm_contentBox">
                <div class="betSlip-match">
                    <SvgIcon iconName="sportIcon_soccer" />
                    <span
                        v-if="mainScoreDisplay"
                        class="live-score"
                        data-testid="bet-builder-slip-main-score"
                    >{{ mainScoreDisplay }}</span>
                    <span class="teamName">{{ betSlip.match.homeTeamName }} - {{ betSlip.match.awayTeamName }}</span>
                </div>
                <MediumBetBuilderTicket
                    v-for="subBet in betSlip.tickets"
                    v-bind:key="subBet.selection.id"
                    v-bind:subBet="subBet"
                    v-bind:scoreDisplay="getTicketScoreDisplay(subBet)"
                />
                <div
                    v-if="!isValidSubBetCount"
                    class="sm_add MiniParlaySlip_Img_AddOneMoreBet betSlip-addMore"
                    v-on:click="collapseMiniBetBuilderBetSlip"
                >
                    <p>
                        <I18nT keypath="betSlip_betBuilder_addMoreLeg">
                            <template #highlightedText>
                                <span class="highlight">{{ i18n.t('betSlip_betBuilder_addMoreLegHighlightedText', { count: countOfAddMore }) }}</span>
                            </template>
                        </I18nT>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { defineComponent } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import MediumBetBuilderTicket from '@/components/betSlip/MediumBetBuilderTicket.vue';
    import { RoutePage } from '@/interface/enum';
    import { useBetBuilderSlipScore } from '@/libraries/composables/useBetBuilderSlipScore';
    import { i18n } from '@/libraries/i18n';
    import { useBetBuilderBetSlipStore } from '@/stores/betSlip/betBuilderBetSlipStore';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useRootStore } from '@/stores/rootStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'MediumBetBuilderBetSlipContent',
        components: {
            MediumBetBuilderTicket,
            SvgIcon,
        },
        setup() {
            const { setTopScreenToast } = useRootStore();
            const { showMiniBetSlip } = useBetSlipStore();

            const {
                betSlip,
                countOfAddMore,
                isValidSubBetCount,
            } = storeToRefs(useBetBuilderBetSlipStore());
            const {
                refreshOnMainScoreChanged,
                removeBetSlip,
            } = useBetBuilderBetSlipStore();

            const router = useRouter();
            const route = useRoute();
            const collapseMiniBetBuilderBetSlip = () => {
                showMiniBetSlip();
                if (route.name !== RoutePage.Main && route.name !== RoutePage.MainBySport) {
                    router.push({ name: RoutePage.Main });
                }
            };

            const { mainScoreDisplay, getTicketScoreDisplay, onSubscription } = useBetBuilderSlipScore();

            onSubscription(async (event) => {
                if (!event) {
                    await removeBetSlip();
                    setTopScreenToast({
                        status: 'error',
                        messageKey: i18n.t('betSlip_errorMessage_eventClosed'),
                    });
                    return;
                }

                await refreshOnMainScoreChanged({
                    home: event.mainMarketEventResult.liveHomeScore,
                    away: event.mainMarketEventResult.liveAwayScore,
                });
            });

            return {
                i18n,
                isValidSubBetCount,
                betSlip,
                countOfAddMore,
                collapseMiniBetBuilderBetSlip,
                mainScoreDisplay,
                getTicketScoreDisplay,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/miniMpTicketContent";
</style>
